var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAttention = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "64px",
    viewBox: "0 0 65 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attention",
    transform: "translate(-688.000000, -204.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(688.000000, 204.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5882353,9.16078431 C41.9917718,-3.07272924 21.9066885,-2.92594113 9.49037369,9.49037369 C-2.92594113,21.9066885 -3.07272924,41.9917718 9.16078431,54.5882353 C17.5238011,62.9414682 29.794063,66.0357752 41.1181176,62.6472157 C42.7701179,62.1433677 43.7041733,60.3990282 43.207792,58.7447691 C42.7114106,57.0905101 40.9713077,56.1485856 39.3148235,56.6374902 C36.9009552,57.3606373 34.3943708,57.7271761 31.8745098,57.7254902 C17.6200784,57.7254902 6.02352941,46.1289412 6.02352941,31.8745098 C6.02352941,17.6200784 17.6200784,6.02352941 31.8745098,6.02352941 C46.1289412,6.02352941 57.7254902,17.6200784 57.7254902,31.8745098 C57.7345136,36.9134005 56.2640384,41.8440743 53.4964706,46.054902 C52.5708758,47.5017356 52.9807812,49.4238873 54.4160934,50.3672494 C55.8514055,51.3106116 57.7784648,50.9244353 58.739451,49.5008627 C67.0870126,36.768711 65.3538142,19.9260889 54.5882353,9.16078431 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7372549,16.5647059 L28.7372549,36.5176471 C28.7372549,38.2503051 30.1418518,39.654902 31.8745098,39.654902 C33.6071678,39.654902 35.0117647,38.2503051 35.0117647,36.5176471 L35.0117647,16.5647059 C35.0117647,14.8320478 33.6071678,13.427451 31.8745098,13.427451 C30.1418518,13.427451 28.7372549,14.8320478 28.7372549,16.5647059 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8745098,50.3215686 C30.1418518,50.3215686 28.7372549,48.9169718 28.7372549,47.1843137 C28.7372549,45.4516557 30.1418518,44.0470588 31.8745098,44.0470588 C33.6071678,44.0470588 35.0117647,45.4516557 35.0117647,47.1843137 C35.0117647,48.9169718 33.6071678,50.3215686 31.8745098,50.3215686 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttention);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attention.21aadb0610ec586137cdde54a7834460.svg";